export default __webpack_public_path__ + "070fd9e9969b10c1128591bffc344a16.svg";